import { render, staticRenderFns } from "./InsightsRadar.vue?vue&type=template&id=a862e980&scoped=true"
import script from "./InsightsRadar.vue?vue&type=script&lang=js"
export * from "./InsightsRadar.vue?vue&type=script&lang=js"
import style0 from "./InsightsRadar.vue?vue&type=style&index=0&id=a862e980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a862e980",
  null
  
)

export default component.exports